import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';


export interface Accountsgroup {
    id?: string;
    accountsGroupName: string;
    headCode:string;
    headSubCode:string;
    createdBy:number;
    createdDate: Date;
    updatedBy: number;
    updatedDate: Date; 
    tenantId: any;
    branchId: any; 
}

export abstract class AccountsgroupTypeData {
    abstract list(url: string): Observable<Accountsgroup[]>;
    abstract create(url: string,data: Accountsgroup): Observable<any>;
    abstract update(url: string,data: Accountsgroup): Observable<any>;
    abstract delete(url: string): Observable<any>;
    abstract getall(url: string): Observable<any>;
  
}
